import { NgModule } from '@angular/core';
import { combineReducers, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {
  heatpumpsReducers,
  heatpumpsSelectorKey,
} from './store/heatpumps.state';
import { HeatpumpsFunnelEffects } from './store/heatpumps-funnel/heatpumps-funnels.effects';
import { HeatpumpsWizardEffects } from './store/heatpumps-wizard/heatpumps-wizard.effects';
import { HeatpumpsQuestionnaireEffects } from './store/heatpumps-questionnaire/heatpumps-questionnaire.effects';
import { HeatpumpsOrderFormEffects } from './store/heatpumps-order-form/heatpumps-order-form.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(
      heatpumpsSelectorKey,
      combineReducers(heatpumpsReducers)
    ),
    EffectsModule.forFeature([
      HeatpumpsFunnelEffects,
      HeatpumpsWizardEffects,
      HeatpumpsQuestionnaireEffects,
      HeatpumpsOrderFormEffects,
    ]),
  ],
})
export class HeatpumpsBootstrapModule {}
